import { useContext, useMemo } from "react";
import UserContext from "../../../contexts/UserContext";
import { ICompanyList } from "../types/common";

const COLLABORATOR_ACCESS_FULL = 1000;

export const useHasCompanyListEditAccess = (companyList?: ICompanyList) => {
  const userModel = useContext(UserContext);

  return useMemo(() => {
    if (!companyList || !userModel) return false;

    const user = userModel.getUser();
    if (user.uid === companyList.uid) return true;

    const collaborators = companyList.collaborators ?? [];
    return collaborators.some(
      (c) => c.entity_id === user.uid && c.access === COLLABORATOR_ACCESS_FULL
    );
  }, [userModel, companyList]);
};

export default useHasCompanyListEditAccess;
